import Example from '@/assets/images/example.jpg'
import ColorWhiteImage from '@/assets/images/colors/white.jpg'
import ColorChampagnerImage from '@/assets/images/colors/champagner.jpg'
import ColorAluminiumImage from '@/assets/images/colors/aluminium.jpg'
import ColorAnthrazitImage from '@/assets/images/colors/anthrazit.jpg'
import LightingUpImage from '@/assets/images/lighting/up.png'
import LightingDownImage from '@/assets/images/lighting/down.png'
import NoLightingImage from '@/assets/images/lighting/no.png'
import Wall from '@/models/Wall'
import Form from '@/models/Form'

export const colors = [
    { name: Wall.LIGHT_COLOR.RGB, bg: 'rgb' },
    { name: Wall.LIGHT_COLOR.WARMWHITE, bg: 'orange-200', color: 'orange-700' },
    { name: Wall.LIGHT_COLOR.WHITE, bg: 'white-bordered', color: 'black' },
]

export const lighting = [
    { name: Wall.LIGHTING.UP, image: LightingUpImage },
    { name: Wall.LIGHTING.DOWN, image: LightingDownImage },
    { name: Wall.LIGHTING.NONE, bg: 'gray-500', image: NoLightingImage }
]

export const kundentyp = [
    { name: Form.CUSTOMER_TYPE.WHOLESALE },
    { name: Form.CUSTOMER_TYPE.PROCESSOR },
    { name: Form.CUSTOMER_TYPE.ARCHITECT },
    { name: Form.CUSTOMER_TYPE.SPECIALIST_MARKET },
    { name: Form.CUSTOMER_TYPE.OTHER },
]

export const bar_color = [
    { name: Wall.BAR_COLOR.WHITE, bg: 'white-bordered', color: 'black', image: ColorWhiteImage },
    { name: Wall.BAR_COLOR.CHAMPAGNER, bg: 'orange-200', color: 'orange-700', image: ColorChampagnerImage },
    //{ name: Wall.BAR_COLOR.SILVER, bg: 'gray-500', image: ColorSilverImage }
    { name: Wall.BAR_COLOR.ALUMINIUM, bg: 'gray-500', image: ColorAluminiumImage },
    { name: Wall.BAR_COLOR.ANTHRAZIT, bg: 'gray-800', image: ColorAnthrazitImage }, // bg-gray-800
]

export default {
    bar_color,
    kundentyp,
    colors,
    lighting,
}